import { httpClient } from '@/shared/lib/http-client';
import { API_ENDPOINTS } from '@/shared/config/api';

export interface IndexPageSettings {
  id: number;
  reviewsWidgetCode: string | null;
  heroImageUrl: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface IndexPageSettingsResponse {
  success: boolean;
  settings: IndexPageSettings;
  message?: string;
}

export interface UpdateIndexPageSettingsData {
  reviewsWidgetCode?: string | null;
  heroImageUrl?: string | null;
}

export const indexPageSettingsApi = {
  async get(): Promise<IndexPageSettingsResponse> {
    const response = await httpClient.get<IndexPageSettingsResponse>(
      API_ENDPOINTS.INDEX_PAGE_SETTINGS.GET
    );
    return response.data;
  },

  async update(data: UpdateIndexPageSettingsData): Promise<IndexPageSettingsResponse> {
    const response = await httpClient.patch<IndexPageSettingsResponse>(
      API_ENDPOINTS.INDEX_PAGE_SETTINGS.UPDATE,
      data
    );
    return response.data;
  },

  async uploadHeroImage(
    file: File,
    onProgress?: (event: { loaded: number; total?: number }) => void
  ): Promise<IndexPageSettingsResponse> {
    const response = await httpClient.uploadFile<IndexPageSettingsResponse>(
      API_ENDPOINTS.INDEX_PAGE_SETTINGS.UPLOAD_HERO_IMAGE,
      file,
      'image',
      onProgress
    );
    return response.data;
  },

  async deleteHeroImage(): Promise<IndexPageSettingsResponse> {
    const response = await httpClient.delete<IndexPageSettingsResponse>(
      API_ENDPOINTS.INDEX_PAGE_SETTINGS.DELETE_HERO_IMAGE
    );
    return response.data;
  }
};
